import { State } from '../../types';

export const oklahoma: State = {
  name: 'Oklahoma',
  abbreviation: 'OK',
  terms: [
    {
      word: 'Achille',
      phonetic: 'a-CHILL-ee',
      // audioUrl: '/audio/achille.mp3',
      description: 'A town in Bryan County, often mispronounced due to its resemblance to "Achilles." The correct pronunciation is "a-CHILL-ee."'
    },
    {
      word: 'Bokchito',
      phonetic: 'BOHK-chee-tah',
      // audioUrl: '/audio/bokchito.mp3',
      description: 'A town in Bryan County, with a name meaning "big creek" in Choctaw. Often mispronounced due to its unique spelling.'
    },
    {
      word: 'Checotah',
      phonetic: 'sheh-COH-tuh',
      // audioUrl: '/audio/checotah.mp3',
      description: 'A city in McIntosh County, named after Samuel Checote, the first chief of the Creek Nation after the Civil War. Commonly mispronounced due to the "Ch" beginning.'
    },
    {
      word: 'Chickasha',
      phonetic: 'CHICK-uh-shay',
      // audioUrl: '/audio/chickasha.mp3',
      description: 'A city in Grady County, with a name derived from the Choctaw word for "Chickasaw." Often mispronounced due to its spelling.'
    },
    {
      word: 'Coweta',
      phonetic: 'co-WEE-tuh',
      // audioUrl: '/audio/coweta.mp3',
      description: 'A city in Wagoner County, named after a Creek Indian war town. The pronunciation emphasizes the second syllable.'
    },
    {
      word: 'Eufaula',
      phonetic: 'you-FAW-luh',
      // audioUrl: '/audio/eufaula.mp3',
      description: 'A city in McIntosh County, named after a Muscogee Creek tribe. Often mispronounced due to its unique combination of vowels.'
    },
    {
      word: 'Hobart',
      phonetic: 'HO-bert',
      // audioUrl: '/audio/hobart.mp3',
      description: 'A city in Kiowa County, named after Garret Hobart, 24th Vice President of the U.S. Pronounced with a silent "a."'
    },
    {
      word: 'Miami',
      phonetic: 'my-AM-uh',
      // audioUrl: '/audio/miami.mp3',
      description: 'A city in Ottawa County, pronounced differently from Miami, Florida. The local pronunciation is "my-AM-uh."'
    },
    {
      word: 'Nowata',
      phonetic: 'NO-wah-tuh',
      audioUrl: '/audio/nowata.mp3',
      description: 'City in northeastern Oklahoma'
    },
    {
      word: 'Okmulgee',
      phonetic: 'ok-MUHL-gee',
      // audioUrl: '/audio/okmulgee.mp3',
      description: 'A city in Okmulgee County, named after a Creek word meaning "boiling waters." Often mispronounced due to its complex spelling.'
    },
    {
      word: 'Ouachita',
      phonetic: 'WAH-shuh-tah',
      // audioUrl: '/audio/ouachita.mp3',
      description: 'Refers to a mountain range, river, and county, with a name of French origin. The pronunciation is "WAH-shuh-tah."'
    },
    {
      word: 'Poteau',
      phonetic: 'POH-toh',
      // audioUrl: '/audio/poteau.mp3',
      description: 'A city in Le Flore County, with a French name meaning "post." Often mispronounced due to its French spelling.'
    },
    {
      word: 'Sallisaw',
      phonetic: 'SAL-ih-saw',
      // audioUrl: '/audio/sallisaw.mp3',
      description: 'A city in Sequoyah County, with a name derived from the French word "salaison," meaning "salt provisions."'
    },
    {
      word: 'Skiatook',
      phonetic: 'SKY-uh-took',
      // audioUrl: '/audio/skiatook.mp3',
      description: 'A city in Osage and Tulsa counties, with a name believed to mean "big injun me" in Cherokee.'
    },
    {
      word: 'Tahlequah',
      phonetic: 'TAH-luh-kwah',
      // audioUrl: '/audio/tahlequah.mp3',
      description: 'A city in Cherokee County, the capital of the Cherokee Nation. Pronounced with emphasis on the first syllable.'
    },
    {
      word: 'Wynnewood',
      phonetic: 'WIN-ee-wood',
      // audioUrl: '/audio/wynnewood.mp3',
      description: 'A city in Garvin County, named after Wynnewood, Pennsylvania. Pronounced with three syllables.'
    }
  ]
};